export class AllocationField{
    public index!: number;
    public name!: string;

}